import {Injectable} from '@angular/core';
import {
  BillingCycleType,
  ICalculateAutomatedPdfPlan,
  ICalculateEstimateItem,
  ProductType,
} from '../../../types/payment.type';
import {MultiSite} from 'src/app/types/site.type';
import {paymentDataStore} from './payment-data.store';
import {setProps} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class PaymentDataManager {
  public setLoading(value: boolean) {
    paymentDataStore.update(setProps({isLoading: value}));
  }

  public setSelectedProduct(product: ProductType) {
    paymentDataStore.update(setProps({selectedProduct: product}));
  }

  public setSites(sites: MultiSite[]) {
    paymentDataStore.update(setProps({sites}));
  }

  public setIsSwitchToAnnual(value: boolean) {
    paymentDataStore.update(setProps({isSwitchingToAnnual: value}));
  }

  public setCustomerId(id: string) {
    paymentDataStore.update(setProps({customerId: id}));
  }

  public setBillingCycle(cycle: BillingCycleType) {
    paymentDataStore.update(setProps({billingCycle: cycle}));
  }

  public setIsTrialActive(value: boolean) {
    paymentDataStore.update(setProps({isTrialActive: value}));
  }

  public setIsSubscriptionOnTrialPeriod(value: boolean) {
    paymentDataStore.update(setProps({isSubscriptionOnTrialPeriod: value}));
  }

  public setEstimatedProductData(data: ICalculateEstimateItem[]) {
    paymentDataStore.update(setProps({estimatedProductData: data}));
  }

  public setAutomatedPdfPlan(data: ICalculateAutomatedPdfPlan[]) {
    paymentDataStore.update(setProps({automatedPdfPlan: data}));
  }

  public setIsOnTrialPeriod(value: boolean) {
    paymentDataStore.update(setProps({isOnTrialPeriod: value}));
  }

  public setBaseDiscountPercentYearly(discount: number) {
    paymentDataStore.update(setProps({baseDiscountPercentYearly: discount}));
  }

  public setBaseDiscountPercentBiAnnual(discount: number) {
    paymentDataStore.update(setProps({baseDiscountPercentBiAnnual: discount}));
  }

  public setIsPaymentLink(isPaymentLink: boolean) {
    paymentDataStore.update(setProps({isPaymentLink}));
  }

  public reset() {
    paymentDataStore.reset();
  }
}
